import 'Lessons/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';

// These are defined in a separate file so they can be mocked out in storybook (see __storybookMocks__/studentDashboardNgDirectives.ts)
export const CurriculumV1 = angularDirectiveToReact('studentDashboardPlaylistsBox', {
    switchLearningBoxMode: '<',
    studentDashboardContent: '<',
    contentProgress: '<',
    projectsForPlaylists: '<',
    modifyHeaderSection: '<',
});
